import React, { Component } from 'react';
import './tips-and-trics-experience.scss';
import LearningContentWrapper from '../exam-prep-kit-learning-content-wrapper/exam-prep-kit-learning-content-wrapper';
import SharedProfile from '../../../../../shared-storage/profile';
import Loading from '../../../common/loading/loading';
import ExamPrepKitApi from '../../../../apis/exam-prep-kit';


export default class TipsAndTricsExperience extends Component {

    workflowEngine = null;
    worflowNodes = [];
    questions = [];
    state = {
        learningElos: [],
        resumeIndex: 0
    };

    CONTENT_FETCH_LIMIT = 5
    contentHash = {}

    constructor(props) {

        super(props);
        // let { navigation } = this.props;
        // this.params = navigation.getParam('meta');
        this.params = this.props.metaInfo;
        this.headerTitle = this.params && this.params.headerTitle ? this.params.headerTitle : ""
        this.progress = null;
        this.userInfo = SharedProfile.getProfile();
        this.getTipsAndTrics()

        if (this.params.resumeIndex) {
            this.state.resumeIndex = this.params.resumeIndex;
            this.lastMaxIndex = this.params.resumeIndex
        }
    }

    learnMoreParam = {}

    componentDidMount() {
        // this.props.navigation.addListener("didFocus", () => {

        //     BackHandler.addEventListener('hardwareBackPress', this.handleBackButtonClick);
        // });

        // this.props.navigation.addListener("didBlur", () => {
        //     BackHandler.removeEventListener('hardwareBackPress', this.handleBackButtonClick);
        // });
    }

    handleBackButtonClick = () => {
        return true
    }

    // buildLearningContent = (contents, callback) => {

    //     let learningElos = this.state.learningElos;

    //     let obj = {
    //         eloId: contents[0].eloId,
    //         eloTitle: contents[0].eloTitle,
    //         categoryThemeId: contents[0].categoryThemeId,
    //         contentId: contents[0].contentId,
    //         contents: [{ title: "", contents: [] }]
    //     }

    //     for (let i = 0; i < contents.length; i++) {
    //         let content = contents[i]
    //         obj.contents[0].contents.push(content)
    //     }

    //     console.log('....obj', obj)

    //     learningElos.push(obj)

    //     this.setState({ learningElos }, () => {
    //         if (callback)
    //             callback()
    //     })
    // }

    onPressNext = (activeIndex, callback) => {
        callback && callback()
    }

    learningElosCompleted = () => {

        if (this.params.isTipsAndTricsCompleted) {
            // this.props.navigation.goBack()
            this.goBackToTableOfContents()
            return
        }

        this.updateCommonErrorCompleted(() => {
            // this.props.navigation.goBack()
            this.goBackToTableOfContents()
        })
    }

    close = () => {
        this.props.navigation.goBack()
    }

    goToLateralMenu = () => {
        this.props.navigation.navigate('LateralMenu')
    }

    getTipsAndTrics = () => {

        let payload = {
            chapterKey: this.params.chapterKey
        }

        this.setState({ loading: true })
        ExamPrepKitApi.getTipsAndTrics(payload).then((response) => {

            this.setState({ loading: false })
            this.buildLearningContent(response)
        }).catch(err => {
            console.log(err);
            this.setState({ loading: false })

            if (err) {
                this.learningElosCompleted()
                return
            }
        })

    }

    next = (index) => {

        if (this.params.isTipsAndTricsCompleted || this.lastMaxIndex > index)
            return

        this.lastMaxIndex = index

        let payload = {
            chapterKey: this.params.chapterKey,
            resumeId: index,
            type: "TIPS_AND_TRICKS"
        }

        ExamPrepKitApi.updatePrepKitActivity(payload).then((response) => {
            this.buildLearningContent(response)
        }).catch(err => {
            console.log(err);
            if (err) {
                this.learningElosCompleted()
                return
            }
        })

    }


    buildLearningContent = (contents, callback) => {

        let learningElos = this.state.learningElos;

        for (let i = 0; i < contents.length; i++) {
            let content = contents[i]
            learningElos.push({
                eloId: content.eloId,
                eloTitle: content.eloTitle,
                categoryThemeId: this.params && this.params.categoryThemeId ? this.params.categoryThemeId : "1",
                contentId: content.contentId,
                contents: [{ title: "", contents: [content] }]
            })
        }

        this.setState({ learningElos }, () => {
            if (callback)
                callback()
        })
    }

    updateCommonErrorCompleted = (callback) => {

        let payload = {
            chapterKey: this.params.chapterKey,
            type: "TIPS_AND_TRICKS"
        }

        this.setState({ loading: true })
        ExamPrepKitApi.updatePrepKitProgress(payload).then((response) => {
            callback && callback()
            this.setState({ loading: false })
        }).catch(err => {
            console.log(err);
            this.setState({ loading: false })
            if (err) {
                return
            }
        })
    }

    onClickLateralMenu = () => {
        this.props.navigation.navigate('LateralMenu', { meta: { from: 'PREPKIT' } })
    }

    goToHomeScreen() {
        this.props.delegate && this.props.delegate.goToHomeScreen && this.props.delegate.goToHomeScreen()
    }

    goToExamPrepKit() {
        this.props.delegate && this.props.delegate.goToExamPrepKit && this.props.delegate.goToExamPrepKit()
    }

    goToExamPrepKitChapterList() {
        this.props.showPrepKitChapterList && this.props.showPrepKitChapterList()
    }

    goBackToTableOfContents() {
        this.props.delegate && this.props.delegate.hideTipsAndTricksExperience && this.props.delegate.hideTipsAndTricksExperience()
    }

    goToPrepare() {
        this.props.delegate && this.props.delegate.goToPrepare && this.props.delegate.goToPrepare()
    }


    renderBreadcrumbForChapterList = () => {
        return (
            <div className='breadcrumb mt-2'>
                <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()} >{`Home >`}</span>
                {/* <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goToExamPrepKit()} >{`Prepare`}{` > `}</span> */}
                <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goToPrepare()}>{`${this.params.title}`} {` > `}</span>
                <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goBackToTableOfContents()}>{`${`Table of Contents`}`} {` > `}</span>
                <span className='title-1 pl-2' >{`Tips and Tricks`}</span>
            </div>
        )
    }



    render() {

        return (
            <div className='prep-kit-tips-and-trics-experience'>
                {
                    this.renderBreadcrumbForChapterList()
                }
                {this.state.learningElos.length > 0 ? <LearningContentWrapper
                    elo={this.state.learningElos}
                    delegate={this}
                    navigation={this.props.navigation}
                    isRevise={this.isRevise}
                    title={this.params.title ? this.params.title : ''}
                    navigationInfo={this.params}
                    eloIds={this.eloIds}
                    noBlur={true}
                    headerIcon={this.params.headerIcon}
                    headerTitle={"Tips and Tricks"}
                    removeHeaderIcon
                    onPressNext={this.onPressNext}
                    activeIndex={this.state.resumeIndex}
                    allPagesActive={this.params.isTipsAndTricsCompleted}
                >
                </LearningContentWrapper> : <Loading />}
            </div>
        )
    }
}